import * as React from 'react';
import FilterDropdown from './FilterDropdown';
import {
  CompetencyFilterOptionData,
  ProductTypeFilterOptionData,
  getProductTypeLabel,
} from './Utils';

interface Props {
  competencyOptions: CompetencyFilterOptionData[];
  productTypeOptions: ProductTypeFilterOptionData[];
  selectedCompetencies: string[];
  selectedProductTypes: string[];
  onCompetenciesChange: (values: string[]) => void;
  onProductTypesChange: (values: string[]) => void;
}

const FilterBar: React.FC<Props> = ({
  competencyOptions,
  productTypeOptions,
  selectedCompetencies,
  selectedProductTypes,
  onCompetenciesChange,
  onProductTypesChange,
}) => (
  <div className="flex flex-row gap-3 mb-4" data-intercom-target="curated-sections-filter-bar">
    <FilterDropdown
      label="Competency"
      options={competencyOptions}
      selectedValues={selectedCompetencies}
      onChange={onCompetenciesChange}
      data-intercom-target="curated-sections-competency-filter"
    />
    <FilterDropdown
      label="Product Type"
      options={productTypeOptions}
      selectedValues={selectedProductTypes}
      onChange={onProductTypesChange}
      getDisplayLabel={getProductTypeLabel}
      data-intercom-target="curated-sections-product-type-filter"
    />
  </div>
);

export default FilterBar;
